<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      新規登録（搬入予約）
    </h2>
    <forms />
  </v-container>
</template>

<script>

import Forms from './_Form.vue'

export default {
  name: 'DriverOrderAcceptCarryInNew',
  components: {
    Forms
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true },
        { text: '搬入新規登録', disabled: true, to: '' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>
